import { render, staticRenderFns } from "./ValidateWeetButton.vue?vue&type=template&id=98d222b4&scoped=true"
import script from "./ValidateWeetButton.vue?vue&type=script&lang=ts"
export * from "./ValidateWeetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d222b4",
  null
  
)

export default component.exports